module.exports = __webpack_public_path__ + "img/download_gift1.feb5acc6.png";